import Observer from "./Observer";

/**
 * Represents object that can be registered to DocumentClickSubject and its callback fired after notification.
 */
 export default class ClickObserver extends Observer {

  /**
   * Constructor
   *
   * @param {Function} callback that will be fired on update
   * ! If we want to use callback in instance, we need to bind it when passing to constructor
   */
  constructor(callback) {
    super(callback);
  }

  /**
   * Fires after being notified by ObservableSubject
   *
   * @param {Element} $clickedElement jQuery element
   */
  update($clickedElement) {
    this.callback($clickedElement);
  }
}
